import { useCallback, useEffect, useRef } from 'react';
import { useBlocker } from 'react-router-dom';
import { useSystemPopup } from '../components/common/SystemPopup';

/** 3.0 offline.js $locationChangeStart — write/confirm 중 SPA 이탈 confirm (beforeunload 미사용). */
function offlineApplyLeaveMessageContent() {
  return (
    <p className="strong-text">
      이 페이지를 벗어나면<br />
      입력하신 모든 정보가 초기화 됩니다.
    </p>
  );
}

/**
 * 좌담회 신청 form/questions/confirm — SPA 라우트 이탈·브라우저 뒤로가기 시 3.0과 동일 안내.
 * @param {boolean} enabled
 */
export function useOfflineApplyLeaveGuard(enabled) {
  const { open: openSystemPopup } = useSystemPopup();
  const leaveConfirmedRef = useRef(false);

  useEffect(() => {
    if (!enabled) {
      leaveConfirmedRef.current = false;
    }
  }, [enabled]);

  const confirmLeave = useCallback(() => {
    leaveConfirmedRef.current = true;
  }, []);

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      enabled
      && !leaveConfirmedRef.current
      && currentLocation.pathname !== nextLocation.pathname,
  );

  useEffect(() => {
    if (blocker.state !== 'blocked') {
      return;
    }
    openSystemPopup({
      type: 'confirm',
      content: offlineApplyLeaveMessageContent(),
      confirmText: '확인',
      cancelText: '취소',
      onConfirm: () => {
        confirmLeave();
        blocker.proceed?.();
      },
      onCancel: () => {
        blocker.reset?.();
      },
    });
  }, [blocker, confirmLeave, openSystemPopup]);

  return { confirmLeave };
}
